<template>
  <form action="">
    <div>
      <span>Период с:</span>
      <span class="inline-date">
        <el-date-picker size="medium" type="date"></el-date-picker>
      </span>
      <span>по</span>
      <span class="inline-date">
        <el-date-picker size="medium" type="date"></el-date-picker>
      </span>
    </div>
    <el-row>
      <el-col :sm="12">
        <div>
          <el-checkbox label="Аккаунт"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="Тип платежа"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="Сумма платежа"></el-checkbox>
        </div>
        <div>
          <el-checkbox :label="$t('status')"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="Платежное средство"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="Дата создания"></el-checkbox>
        </div>
        <div>
          <el-checkbox :label="$t('batch_date')"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="Счет"></el-checkbox>
        </div>
        <div>
          <el-checkbox :label="$t('notes')"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="Имя счета мерчанта"></el-checkbox>
        </div>
      </el-col>
      <el-col :sm="12">
        <div>
          <el-checkbox label="ID в журнале"></el-checkbox>
        </div>
        <div>
          <el-checkbox :label="$t('transaction_id')"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="Номер платежного средства"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="Тип платежного средства"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="IP плательщика"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="Код ответа"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="Текст ответа"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="3DS"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="Approval"></el-checkbox>
        </div>
        <div>
          <el-checkbox :label="$t('processing_gateway')"></el-checkbox>
        </div>
      </el-col>
    </el-row>
  </form>
</template>

<script>
export default {
  name: 'payment-form'
}
</script>
